import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ButtonComponent from '../../common/ButtonComponent';
import SiteHeaderActionCreator from '../../../actions/SiteHeaderActionCreator';
import SvgIcon from '../../common/SvgIcon';

/** store # url as a variable to suppress eslint false-positive */
const hashHref = '#';

class Panel extends Component {
  constructor(props) {
    super(props);
    this.showSideBarMobile = this.showSideBarMobile.bind(this);
    this.displaySideNavInformation = this.displaySideNavInformation.bind(this);
    this.linkClicked = this.linkClicked.bind(this);

    /**
     * @note moved from deprecated `componentWillMount()` lifecycle method.
     */
    SiteHeaderActionCreator.setSideBarFlag(true);
  }

  componentWillUnmount() {
    SiteHeaderActionCreator.setSideBarFlag(false);
  }

  showSideBarMobile() {
    this.props.showSideBarMobile(false);
  }

  displaySideNavInformation() {
    return this.props.SideBarlist.map((li, index) => (
      <div
        key={`SideNavInfo_${li.headerName}_${index}`}
        className="c-panel-info"
      >
        <h2 className="c-panel__heading">
          <span className={'c-panel__icons'}>
            <SvgIcon id={li.icon} width="16px" height="16px" />
          </span>
          {li.headerName}
        </h2>
        {li.links[0].linkName === 'Turn off insurance' && (
          <p className="insurance-text">
            Your insurance is <span className="fw-bold">on</span> - you pay a
            monthly fee of £14.00 for this cover.
          </p>
        )}
        {(li.links[0].id === 'privateBankingBenefits' ||
          li.links[0].id === 'currentAccountTracker') && (
          <p className="insurance-text">
            You pay <span className="fw-bold">£15.00</span> per month for
            maintaining your account and services of a dedicated Private
            Manager.
          </p>
        )}
        {li.links[0].id === 'upgradeAccount' && (
          <p>
            Give us a call on <span className="fw-bold">0800 121 7365</span> and
            we'll help find the best option for you.
          </p>
        )}
        <div className="c-panel__body">
          <ul className="c-panel__list">
            {li.links.map((link, index) => (
              <li
                className="c-panel__item"
                key={`Panel_li_c-panel__item_${index}`}
                onClick={this.linkClicked.bind(this, link.id)}
              >
                <a className="c-panel__sblink" id={link.id} href={hashHref}>
                  {' '}
                  {link.linkName}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    ));
  }

  linkClicked(listid, e) {
    this.props.linkClicked(e, listid);
  }

  render() {
    return (
      <aside
        id="site-sidebar"
        className={`c-side-bar ${this.props.className}`}
        tabIndex="-1"
      >
        <div className="c-side-bar__button text-right">
          <ButtonComponent
            onClick={this.showSideBarMobile}
            btnName="Close"
            className="c-btn c-btn--link"
          />
        </div>
        {this.props.sideBarButtons ? this.props.sideBarButtons : ''}
        <div className="c-panel">{this.displaySideNavInformation()}</div>
      </aside>
    );
  }
}

Panel.propTypes = {
  accountType: PropTypes.string,
  className: PropTypes.string,
  SideBarlist: PropTypes.array,
  showSideBarMobile: PropTypes.func,
  linkClicked: PropTypes.func,
  sideBarButtons: PropTypes.string,
};

Panel.defaultProps = {
  accountType: 'current',
  SideBarlist: [],
  className: '',
  sideBarButtons: '',
};

export default Panel;
